import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';

import { filter, map, mergeMap } from 'rxjs';

import { TopNavbarService } from '@shared/services/topNavbar/topNavbar.service';
import { ProgressBar } from '@shared/components/progress-bar/progress-bar';
import { UserService } from '@app/features/profile/services/user.service';
import { environment } from '@environments/environment';
import { Toaster } from '@shared/components/toaster/toaster';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule, Toaster, ProgressBar],
  providers: [TopNavbarService],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    public topNavbar: TopNavbarService,
    private userService: UserService,
    private titleService: Title,
    private router: Router,
  ) {

  }
  ngOnInit(): void {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map(route => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        mergeMap(route => route.data)
      )
      .subscribe(data => {
        const title = data['routeTitle'] || environment.app_title;
        this.titleService.setTitle(title);
      });
    const cached = localStorage.getItem('userDetail');
    if (cached) {
      this.userService.userDetail.set(JSON.parse(cached));
    }
    const token = localStorage.getItem('authToken');
    if (token) {
      this.userService.getUserProfile().subscribe({
        next: ((res) => {
          if (res.success === true) {
            this.userService.setUserDetail(res.data)
          }
        })
      })
    }
  }
}
